import { useKeyboardEvents } from 'dashboard/composables/useKeyboardEvents';
import { useShortcutEvents } from 'dashboard/composables/useKeyboardShortcuts';
import { SHORTCUT_ACTIONS } from 'dashboard/components/widgets/modal/constants';
import { useRoute, useRouter } from 'vue-router';

/**
 * 侧栏相关快捷键：打开快捷键弹窗、跳转主要模块。
 * 关闭弹窗（$mod+Escape）保持固定，不纳入可自定义范围。
 * @param {(open: boolean) => void} toggleShortcutModalFn
 */
export function useSidebarKeyboardShortcuts(toggleShortcutModalFn) {
  const route = useRoute();
  const router = useRouter();

  /** 当前路由是否已是目标，避免重复 push */
  const isCurrentRouteSameAsNavigation = routeName => {
    return route.name === routeName;
  };

  /** 导航到指定命名路由 */
  const navigateToRoute = routeName => {
    if (!isCurrentRouteSameAsNavigation(routeName)) {
      router.push({ name: routeName });
    }
  };

  // 关闭弹窗保持固定绑定
  useKeyboardEvents({
    '$mod+Escape': {
      action: () => toggleShortcutModalFn(false),
    },
  });

  return useShortcutEvents({
    [SHORTCUT_ACTIONS.TOGGLE_MODAL]: {
      action: () => toggleShortcutModalFn(true),
    },
    [SHORTCUT_ACTIONS.GO_TO_CONVERSATION_DASHBOARD]: {
      action: () => navigateToRoute('home'),
    },
    [SHORTCUT_ACTIONS.GO_TO_CONTACTS_DASHBOARD]: {
      action: () => navigateToRoute('contacts_dashboard'),
    },
    [SHORTCUT_ACTIONS.GO_TO_REPORTS_SIDEBAR]: {
      action: () => navigateToRoute('account_overview_reports'),
    },
    [SHORTCUT_ACTIONS.GO_TO_SETTINGS]: {
      action: () => navigateToRoute('agent_list'),
    },
  });
}
